'use client';

/**
 * Väljer bilen när kunden kommer via en kort länk i ett svar på Facebook/Instagram
 * (autofrance.se/s/<kod>). API:t sätter kakan af_fordon = ktype vid omdirigeringen — ALDRIG
 * regnumret, länken står i en offentlig kommentar och delas. Här väljs bilen på samma sätt som
 * när kunden själv söker (båda butikerna: huvudets "Välj bil" och varukorgens passformskontroll),
 * och kakan tas bort. Ägaren 2026-09-29: "reg numret används inte när man trycker på länken".
 */
import { useEffect } from 'react';
import { useVehicleStore } from '@/stores/vehicle';
import { useCartStore } from '@/stores/cart';

const API = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3001/api';

export function FordonFranLank() {
  useEffect(() => {
    const m = document.cookie.match(/(?:^|;\s*)af_fordon=(\d{1,9})/);
    if (!m) return;
    document.cookie = 'af_fordon=; Max-Age=0; path=/; SameSite=Lax; Secure';
    const ktype = Number(m[1]);
    if (useVehicleStore.getState().vehicle?.ktype === ktype) return;
    fetch(`${API}/vehicles/${ktype}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((v) => {
        if (!v?.ktype) return;
        const fordon = {
          ktype: v.ktype, manufacturer: v.manufacturer, model: v.model, cartype: v.cartype,
          from_year: v.from_year, to_year: v.to_year ?? undefined, fueltype: v.fueltype ?? undefined,
          ccm: v.ccm ?? undefined, hp: v.hp ?? undefined,
        };
        useVehicleStore.getState().setVehicle(fordon);
        useCartStore.getState().setVehicle(fordon as Parameters<ReturnType<typeof useCartStore.getState>['setVehicle']>[0], null, 'kortlank-social');
      })
      .catch(() => {});
  }, []);
  return null;
}
